module.exports = "/images/Family  Entertainment  Center.svg?8d9cabb655787901b1a038962bd1a451";